/** In-page anchors shared by server and client campaign components. */

/** Opens the closing band's message tab (hero link "Hellre skriva?"). */
export const CAMPAIGN_WRITE_HASH = "skriv";
